module.exports = __webpack_public_path__ + "img/down_qa.bdd4a91c.svg";